import { motion } from "framer-motion";
import { Skull } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const TRAITS = [
  "High-caliber horror heroine",
  "Star of comics, prints & co-star of Dark America",
  "100% uncensored. 0% forgiving.",
];

export default function MarySpotlight() {
  return (
    <section id="mary" data-testid="mary-spotlight-section" className="relative py-28 sm:py-36 newsprint-grain overflow-hidden">
      <div className="absolute inset-0 halftone opacity-[0.06] pointer-events-none" />
      <div className="absolute inset-0 blood-vignette pointer-events-none" />
      <div className="absolute -left-32 bottom-0 w-[26rem] h-[26rem] rounded-full bg-blooddeep/20 blur-[130px] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40, rotate: -4 }}
          whileInView={{ opacity: 1, x: 0, rotate: -2 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="group relative spotlight-frame comic-shadow cursor-zoom-in max-w-md mx-auto lg:mx-0 w-full"
        >
          <img
            data-testid="mary-spotlight-image"
            src="/covers/mary-valkyrie.jpg"
            alt="Mary Machinegun artwork"
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-125"
          />
          <div className="absolute inset-0 halftone opacity-0 group-hover:opacity-15 transition-opacity duration-300 pointer-events-none" />
          <span className="absolute top-4 -left-2 bg-blooddeep text-bone font-marker text-xs px-3 py-1 rotate-[-4deg] ink-shadow-sm">
            THE FACE OF ATROCITY
          </span>
        </motion.div>

        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="font-marker text-paper text-base sm:text-lg mb-3 -rotate-1 inline-block"
          >
            meet your new obsession
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase text-paper leading-none mb-8"
          >
            MARY <span className="text-crimson">MACHINEGUN</span>
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <p className="font-type text-sm sm:text-base text-paper/70 leading-relaxed mb-4">
              Every crypt needs a queen. Mary Machinegun is ours — a bullet-riddled bad girl
              who walks out of every horror story standing over the thing that tried to end her.
            </p>
            <p className="font-type text-sm sm:text-base text-paper/70 leading-relaxed mb-8">
              She headlines our comics, haunts our prints, and stares down succubi in
              Dark America. This is her press now. We just load the ink.
            </p>
            <ul className="space-y-3 mb-10">
              {TRAITS.map((t, i) => (
                <motion.li
                  key={t}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + i * 0.12 }}
                  className="flex items-center gap-3 font-courier text-xs sm:text-sm uppercase tracking-widest text-paper/70"
                >
                  <Skull size={14} className="text-crimson shrink-0" /> {t}
                </motion.li>
              ))}
            </ul>
            <a
              data-testid="mary-shop-cta"
              href="/shop"
              className="inline-block font-impact uppercase tracking-wider bg-blooddeep text-white border-2 border-black px-7 py-4 ink-shadow crimson-glow transition-colors duration-150 hover:bg-crimson active:translate-x-1 active:translate-y-1"
            >
              Shop Mary Machinegun
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
